import { render, staticRenderFns } from "./IpServer.vue?vue&type=template&id=1964364c&scoped=true&"
import script from "./IpServer.vue?vue&type=script&lang=js&"
export * from "./IpServer.vue?vue&type=script&lang=js&"
import style0 from "./IpServer.vue?vue&type=style&index=0&id=1964364c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1964364c",
  null
  
)

export default component.exports